import { Dialog, DialogContent } from "../../shadcn/ui/dialog";
import { Drawer, DrawerContent } from "../../shadcn/ui/drawer";
import { cn } from "@punchup/utils/cn";
import { useIsDesktop } from "@punchup/utils/hooks";

interface ModalOrDrawerProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  className?: string;
}

export function ModalOrDrawer({
  isOpen,
  onOpenChange,
  children,
  className,
}: ModalOrDrawerProps) {
  const isDesktop = useIsDesktop();

  const handleOpenChange = (open: boolean) => {
    // Ignore calls where the value hasn't changed
    // This prevents vaul drawer from closing itself during mount
    if (open === isOpen) {
      return;
    }

    onOpenChange(open);
  };

  if (!isDesktop) {
    return (
      <Drawer open={isOpen} onOpenChange={handleOpenChange}>
        <DrawerContent className={cn("max-h-[85vh] p-6", className)}>
          {children}
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent
        className={cn("gap-6 rounded-2xl max-w-2xl w-full", className)}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}
